// Internalizado de @mandae/ng-api 2.13.7 na remoção da dependência.
import { Pipe, PipeTransform } from '@angular/core';
import { InvoiceStatus } from '@mandae/catalogo';

@Pipe({
  name: 'invoiceStatus'
})
export class InvoiceStatusPipe implements PipeTransform {

  transform(value: any): any {
    const status = InvoiceStatus.fromCode<InvoiceStatus>(value) || InvoiceStatus.fromValue<InvoiceStatus>(value);

    if (!status) {
      return '';
    }

    return status.displayValue;
  }

}
